<template>
  <div>
    <v-layout wrap>
      <v-flex
        xs6
        sm4
        md3
        lg2
        class="pa-2"
        style="height: 240px; cursor: pointer"
        v-if="showBlank"
        @click="onSelectedPreset(null)"
      >
        <v-card
          class="preset"
          style="height: 100%;border-radius: 20px;position:relative"
          :class="{ selected: selectedPreset == null && showSelect }"
        >
          <div style="height: 100%;border-radius: 20px;position: relative">
            <div style="position: absolute; right: 0; top: 0" class="mr-2 mt-2">
              <v-avatar
                size="30"
                small
                color="primary"
                class="white--text"
                v-if="selectedPreset == null && showSelect"
              >
                <v-icon small color="white">check</v-icon>
              </v-avatar>
            </div>
            <div style="text-align: center;">
              <img
                class="mt-3"
                src="/static/img/assets/preset/blankbot.png"
                style="width: 70%; margin: auto"
              />
            </div>
          </div>
          <div class="text-xs-center pa-2" style="position: absolute; bottom: 0; left: 0; right: 0">
            <div>{{ $t('Blank Template') }}</div>
            <v-btn small depressed color="primary">{{ $t('Select') }}</v-btn>
          </div>
        </v-card>
      </v-flex>

      <template v-for="(preset, index) in $store.state.presets">
        <v-flex
          v-if="index <= 4"
          :key="`preset_${index}`"
          xs6
          sm4
          md3
          lg2
          class="pa-2"
          style="height: 240px; cursor: pointer"
        >
          <v-card
            class="preset"
            style="height: 100%;border-radius: 20px;position:relative; overflow: hidden"
            @click="onSelectPreset(preset, index)"
            :class="{ selected: selectedPreset == index && showSelect }"
          >
            <div style="position: absolute; left: 0; top: 0" class="mt-2 ml-2">
              <v-chip
                small
                color="blue"
                class="white--text"
                v-if="preset.isPremium && unlockPresets != true"
              >
                <v-icon small>lock</v-icon>
              </v-chip>
            </div>
            <div style="position: absolute; right: 0; top: 0" class="mt-2 mr-2">
              <v-avatar
                size="30"
                small
                color="primary"
                class="white--text"
                v-if="selectedPreset == index && showSelect"
              >
                <v-icon small color="white">check</v-icon>
              </v-avatar>
            </div>
            <div
              style="height: 100%;overflow: hidden;background-position: center;background-size: cover;"
              :style="{ 'background-image': `url('${preset.imagePath}')` }"
            >
              <div
                style="height: 100%;background: rgb(255,255,255);background:linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255) 87%, rgb(255, 255, 255) 100%);"
              ></div>
            </div>
            <div
              class="text-xs-center pa-2"
              style="position: absolute; bottom: 0; left: 0; right: 0"
            >
              <div>{{ $t(preset.name) }}</div>
              <v-btn small depressed color="primary">{{ $t('Select this template') }}</v-btn>
            </div>
          </v-card>
        </v-flex>
      </template>
    </v-layout>

    <v-dialog v-model="showPreset" max-width="1040">
      <v-card v-if="currentViewPreset" :key="currentViewPreset.name">
        <div>
          <v-layout wrap>
            <v-flex sm6 md4 class="hidden-xs-only pt-4 pb-4 primary lighten-3">
              <!-- <div
                style="height: 100%; background: #eee;background-position: center;background-size: cover;"
                :style="{'background-image': `url('${currentViewPreset.imagePath}')`}"
              >
                
              </div>-->
              <div ref="screenshot">
                <div style="max-width: 300px; margin: auto;">
                  <iphone-screen>
                    <div style="height: 100%">
                      <img
                        :src="currentViewPreset.screenshotPath"
                        style="width: 100%;height: 100%;display: block"
                      />
                    </div>
                  </iphone-screen>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md8 class="pa-3">
              <div class="text-xs-right">
                <v-btn flat fab small @click="showPreset = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <v-layout>
                <v-avatar size="100">
                  <img :src="currentViewPreset.imagePath" />
                </v-avatar>
                <v-flex class="px-3">
                  <h2 class="primary--text mt-2 mb-1">{{ currentViewPreset.name }}</h2>
                  <div v-html="currentViewPreset.description"></div>
                </v-flex>
              </v-layout>
              <div class="text-xs-center mt-3">
                <template v-if="currentViewPreset.isPremium && unlockPresets != true">
                  <v-layout
                    class="mb-2"
                    style="border-radius: 20px; border: 1px solid #ff706b;overflow: hidden"
                    v-if="$store.getters.getPackage !== 'premium'"
                  >
                    <template v-for="(premium, index) in $store.state.premiums">
                      <v-flex
                        v-if="premium.type == 'premium'"
                        :key="premium.id"
                        class="pa-3 package"
                        :class="{
                          'white--text primary': selectedPremium.id == premium.id,
                          'left-border': index != 0
                        }"
                        @click="selectedPremium = premium"
                      >
                        <template v-if="premium.price != premium.discount">
                          <div class="caption">
                            {{ $t('premium') }}
                            {{
                              premium.months >= 12
                                ? premium.months / 12 + $t('Year')
                                : premium.months + $t('months')
                            }}
                          </div>
                          {{ premium.discount | numberFormat }} {{ $t('Baht') }}
                          <div
                            class="caption"
                            :class="{ 'grey--text': selectedPremium.id != premium.id }"
                          >
                            {{ $t('from') }}
                            <span style="text-decoration:line-through"
                              >{{ premium.price | numberFormat }} {{ $t('Baht') }}</span
                            >
                          </div>
                        </template>
                        <template v-else>
                          <div class="caption">
                            {{ $t('premium') }}
                            {{
                              premium.months >= 12
                                ? premium.months / 12 + $t('Year')
                                : premium.months + $t('months')
                            }}
                          </div>
                          {{ premium.price | numberFormat }} {{ $t('Baht') }}
                        </template>
                      </v-flex>
                    </template>
                  </v-layout>
                  <div class="mb-2">
                    <v-chip disabled color="primary white--text"
                      >+ {{ $t('300 Baht/Page to unlock all templates') }}</v-chip
                    >
                  </div>
                  <div class="mb-3 red--text">
                    {{ $t('Total') }}
                    {{
                      ((selectedPremium && $store.getters.getPackage !== 'premium'
                        ? selectedPremium.discount
                        : 0) +
                        300)
                        | numberFormat
                    }}
                    {{ $t('Baht') }}
                  </div>
                </template>
                <v-btn depressed :href="currentViewPreset.link" target="_blank">{{
                  $t('Preview in Messenger')
                }}</v-btn>
                <template v-if="currentViewPreset.isPremium && unlockPresets != true">
                  <v-btn depressed color="primary" @click="onPurchasePreset">
                    <v-icon class="mr-1">shopping_cart</v-icon>
                    {{ $t('Purchase') }}
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn depressed color="primary" @click="onSelectedPreset(currentPresetIndex)">
                    <v-icon class="mr-1">check</v-icon>
                    {{ $t('Select this template') }}
                  </v-btn>
                </template>
              </div>

              <v-divider class="mb-3 mt-2"></v-divider>

              <template v-if="currentViewPreset.features">
                <strong>ฟีเจอร์หลัก</strong> :
                <br />
                <ul class="browser-default">
                  <li v-for="feature in currentViewPreset.features" :key="feature">
                    {{ feature }}
                  </li>
                </ul>
                <br />
              </template>
              <template v-if="currentViewPreset.shopservices">
                <strong>มีบริการร้านค้าครบวงจร</strong> :
                <ul class="browser-default">
                  <li v-for="service in currentViewPreset.shopservices" :key="service">
                    {{ service }}
                  </li>
                </ul>
                <br />
              </template>
              <template v-if="currentViewPreset.functions">
                <strong>ทำอะไรได้บ้าง</strong> :
                <ul class="browser-default">
                  <li v-for="func in currentViewPreset.functions" :key="func">{{ func }}</li>
                </ul>
              </template>

              <p v-if="[6, 7, 8, 9, 10].includes(currentPresetIndex + 1)" class="mt-3">
                * วิธีการใช้ฟีเจอร์ ติดแท็ค สามารถหาดูได้ใน แถบบทสนทนา > กดปุ่มรูปดินสอ >
                กดปุ่มเพิ่มเติม
              </p>

              <div
                class="text-xs-center mt-3 mb-3"
                v-if="currentViewPreset.pages && currentViewPreset.pages.length > 0"
              >
                <div class="caption primary--text mb-2">เพจที่ใช้งาน</div>
                <v-avatar size="36px">
                  <img
                    src="https://avatars0.githubusercontent.com/u/9064066?v=4&s=460"
                    alt="Avatar"
                  />
                </v-avatar>
                <v-avatar size="36px">
                  <img
                    src="https://avatars0.githubusercontent.com/u/9064066?v=4&s=460"
                    alt="Avatar"
                  />
                </v-avatar>
                <v-avatar size="36px">
                  <img
                    src="https://avatars0.githubusercontent.com/u/9064066?v=4&s=460"
                    alt="Avatar"
                  />
                </v-avatar>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFeature" max-width="400">
      <v-card>
        <v-card-text>
          <div class="text-xs-right">
            <v-btn flat fab small class="ma-0" @click="showFeature = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <div>
            <div><v-icon class="mr-2" small>chat_bubble</v-icon>การสนทนาเบื้องต้น</div>
            <div><v-icon class="mr-2" small>volume_up</v-icon>บอร์ดแคส</div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showPayment" persistent max-width="800">
      <v-card>
        <v-card-text>
          <div class="text-xs-right">
            <v-btn flat fab small @click="showPayment = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <div style="min-height: 400px" v-if="showPayment && selectedPremium && currentPackage">
            <paypal-payment
              :key="currentPackage"
              :params="currentPackage"
              :type="'paypal'"
              :pack="pack"
              :zwiz_package="selectedPremium"
              :pid="selectedPremium.pid"
              @onClose="onClose"
            ></paypal-payment>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showTransfer" scrollable max-width="1000px">
      <v-card>
        <v-card-text style="height: 300px;" class="pa-0">
          <div class="spinner text-xs-center mt-2 mb-2" v-if="loadingTransfer">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
          <div class="text-xs-center mt-4 mb-4" v-else-if="comparelist.length == 0">
            {{ $t('Choose page to transfer') }}
          </div>
          <div class="pb-2" v-else>
            <v-list-tile style="background: #eee;">
              <v-list-tile-action @click.prevent="toggleSelect(selectAll)">
                <v-checkbox v-model="selectAll" color="primary"></v-checkbox>
              </v-list-tile-action>

              <v-list-tile-content
                @click.prevent="
                  selectAll = !selectAll
                  toggleSelect(selectAll)
                "
              >
                <v-list-tile-title>{{ $t('Select All') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>

            <template v-for="(compare, index) in comparelist">
              <v-list-tile :key="'compare_' + compare.id">
                <v-list-tile-action>
                  <v-checkbox v-model="compare.selected" color="primary"></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click.prevent="compare.selected = !compare.selected">
                  <v-list-tile-title>
                    <template v-if="compare.intentname == '{default}'">{{
                      $t('Default Conversation')
                    }}</template>
                    <template v-else-if="compare.intentname == '{default_comment_to_inbox}'">{{
                      $t('More Comment to Inbox')
                    }}</template>
                    <template v-else-if="compare.intentname == '{welcome}'">{{
                      $t('Welcome Message')
                    }}</template>
                    <template v-else>{{ compare.intentname }}</template>
                  </v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action
                  class="text-xs-center"
                  @click.prevent="compare.selected = !compare.selected"
                >
                  <v-list-tile-action-text v-if="!compare.page2" style="margin: auto;">{{
                    $t('Insert2')
                  }}</v-list-tile-action-text>
                  <v-list-tile-action-text v-else style="margin: auto;" class="info--text">{{
                    $t('Replace')
                  }}</v-list-tile-action-text>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider
                v-if="index + 1 < comparelist.length"
                :key="index"
                class="mt-2"
              ></v-divider>
            </template>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outline color="grey" @click="showTransfer = false">{{ $t('cancel') }}</v-btn>
          <v-btn outline color="primary" :disabled="isSelected == 0" @click="saveTransfer">{{
            $t('Save')
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import IphoneScreen from '@/components/elements/IphoneScreen'
import PaypalPayment from './PaypalPayment'
export default {
  props: ['showSelect', 'showBlank', 'showCompare'],
  components: {
    IphoneScreen,
    PaypalPayment
  },
  data() {
    return {
      showPreset: false,
      showFeature: false,
      showPayment: false,
      showTransfer: false,

      currentViewPreset: null,
      currentPresetIndex: null,
      selectedPreset: null,
      selectedPremium: null,
      screenshotWidth: 0,
      loadingPayment: false,
      pack: '',
      comparelist: [],
      selectAll: false,
      loadingTransfer: false
    }
  },
  mounted() {
    if (this.$store.state.premiums && this.$store.state.premiums.length > 0) {
      if (this.$store.getters.getPackage !== 'premium') {
        this.selectedPremium = this.$store.state.premiums[0]
      } else {
        this.selectedPremium = this.$store.state.premiums[3]
      }
    }
    this.$store.dispatch('loadProducts')
  },
  computed: {
    ...mapGetters({
      botlist: 'botlist',
      isFacebook: 'isFacebook',
      pagelist: 'unsubscribedPage',
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      products: 'getProducts'
    }),
    isSelected: function() {
      return this.comparelist.filter(function(el) {
        return el.selected
      }).length
    },
    currentPackage() {
      var result = ''
      this.pack = ''
      var price = 0
      if (this.selectedPremium && this.$store.getters.getPackage !== 'premium') {
        if (this.selectedPremium.id == 'btn_3month_fb') {
          result = 'btn_3month'
          this.pack = `${this.selectedPremium.months} Months`
          price = this.selectedPremium.discount
        } else if (this.selectedPremium.id == 'btn_6month_fb') {
          result = 'btn_6month'
          this.pack = `${this.selectedPremium.months} Months`
          price = this.selectedPremium.discount
        } else if (this.selectedPremium.id == 'btn_12month_fb') {
          result = 'btn_12month'
          this.pack = `1 Year`
          price = this.selectedPremium.discount
        }
      } else {
        result = 'btn_'
      }
      if (this.selectedBot.unlock_presets != true) {
        result += 'presets_fb'
        this.pack += ' Presets'
        price += 300
      } else {
        result += '_fb'
      }
      this.pack += ` ${price} Baht`
      return result
    },
    unlockPresets() {
      if (this.$route.query.view && this.$route.query.view === 'workshop') {
        return true
      } else {
        return this.selectedBot.unlock_presets
      }
    }
  },
  methods: {
    onClose() {
      this.showPayment = false
    },
    async onSelectedPreset(value) {
      if (value == null) {
        this.showPreset = false
        this.$emit('onChangePreset', value)
      } else {
        var result = await this.$swal.fire({
          title: this.$t('Are you sure you want to select this template?'),
          text: this.$t(
            'Once you confirmed, you cannot go back and the existing conversation will be replaced.'
          ),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          this.selectedPreset = value
          try {
            if (value != null) {
              await this.onClonePreset(value + 1)
            }
            if (!this.showCompare) {
              this.showPreset = false
              this.$emit('onChangePreset', value)
            }
          } catch (error) {
            console.error(error)
            this.$swal.fire({
              title: this.$t('Something went wrong, please try again'),
              type: 'error',
              confirmButtonText: this.$t('Confirm'),
              reverseButtons: true,
              footer: this.$t('if_you_want_any_help_text')
            })
          }
        }
      }
    },
    goBlankBot() {
      this.$router
        .push({ path: '/' + this.currentLang + '/setup', query: this.$route.query })
        .catch(() => {})
    },
    onSelectPreset(preset, index) {
      this.currentViewPreset = preset
      this.currentPresetIndex = index
      this.onSelectedPreset(this.currentPresetIndex)
      // this.showPreset = true
    },
    onScreenshotResize() {
      this.screenshotWidth = this.$refs.screenshot ? this.$refs.screenshot.clientWidth : 0
    },
    onPurchasePreset() {
      this.showPayment = true
      if (this.selectedBot.unlock_presets != true) {
      }
      // this.selectedPreset = this.currentPresetIndex
      // this.showPreset = false
      // this.$emit('onChangePreset', this.selectedPreset)
    },
    async onClonePreset(presetid) {
      var data = {
        pageid1: `preset-${
          this.$route.query.view && this.$route.query.view === 'workshop' ? '11' : ''
        }${presetid}`,
        pageid2: this.selectedBot.pageid
      }
      this.$store.dispatch('loading')
      try {
        var compareintent_response = await this.getCompareIntents(data)
      } catch (error) {
          this.$store.dispatch('loading')
        throw this.$t('Something went wrong, please try again')
      }
      if (this.showCompare) {
        this.showTransfer = true
        this.comparelist = []
        if (compareintent_response.data) {
          compareintent_response.data = compareintent_response.data.sort(function(a, b) {
            var nameA = a.intentname.toLowerCase()
            var nameB = b.intentname.toLowerCase()
            if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
              return 1
            }
            if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
              return -1
            }
            if (nameA < nameB) {
              return -1
            }
            if (nameA > nameB) {
              return 1
            }
          })
          compareintent_response.data.map(
            function(el) {
              let compare = el
              compare.selected = true
              this.comparelist.push(compare)
            }.bind(this)
          )
        }
      } else {
        if (compareintent_response.data) {
          var intentsid = []
          compareintent_response.data.map(function(el) {
            intentsid.push(el.id)
          })

          try {
            let promiseTransfer = this.transferIntent(intentsid)
            let shopservice_response_message = await this.cloneShopService()
            let responsemessage = await promiseTransfer
            // if (responsemessage) {
            //   this.$swal.fire({
            //     title: responsemessage,
            //     type: 'success',
            //     confirmButtonText: this.$t('Confirm'),
            //     reverseButtons: true
            //   })
            // }
          } catch (error) {}
        }
      }

      this.$store.dispatch('loading')
    },

    async saveTransfer() {
      var intentsid = []

      if (this.comparelist) {
        this.comparelist.map(function(el) {
          if (el.selected) {
            intentsid.push(el.id)
          }
        })
        try {
          let promiseTransfer = this.transferIntent(intentsid)
          let shopservice_response_message = await this.cloneShopService()

          let responemessage = await promiseTransfer
          // if (responsemessage) {
          //   this.$swal.fire({
          //     title: responsemessage,
          //     type: 'success',
          //     confirmButtonText: this.$t('Confirm'),
          //     reverseButtons: true
          //   })
          // }

          this.$emit('onChangePreset', this.selectedPreset)
        } catch (error) {
          console.log(error)
        }

        this.showPreset = false
        this.showTransfer = false
      }
    },
    async cloneShopService() {
      if (
        [1, 2, 3, 4, 5, 6, 7, 9, 10].includes(this.currentPresetIndex + 1)
        // && this.products.length == 0
      ) {
        var data = {
          pageid1: `preset-${
            this.$route.query.view && this.$route.query.view === 'workshop' ? '11' : ''
          }${this.currentPresetIndex + 1}`,
          pageid2: this.selectedBot.pageid
        }
        let compareshopservice_response = await this.getCompareShopService(data)

        var categoriesid = []

        if (compareshopservice_response.data) {
          compareshopservice_response.data.map(function(el) {
            categoriesid.push(el.id)
          })
        }

        if (categoriesid.length == 0) {
          return false
        }

        let response = await this.transferShop(categoriesid)
        return Promise.resolve(response)
      } else {
        return Promise.resolve()
      }
    },
    async transferIntent(intentid) {
      if (intentid.length == 0) {
        return Promise.resolve()
      }
      var data = {
        pageid1: `preset-${
          this.$route.query.view && this.$route.query.view === 'workshop' ? '11' : ''
        }${this.currentPresetIndex + 1}`,
        pageid2: this.selectedBot.pageid
      }
      data.intentsid = intentid.join(',')

      try {
        var response = await this.transferIntents(data)
        if (response.message) {
          return Promise.resolve(response.message)
        }
        return Promise.reject()
      } catch (error) {
        return Promise.reject()
      }
    },
    async transferShop(categoriesid) {
      if (categoriesid.length == 0) {
        return Promise.resolve()
      }
      var data = {
        pageid1: `preset-${
          this.$route.query.view && this.$route.query.view === 'workshop' ? '11' : ''
        }${this.currentPresetIndex + 1}`,
        pageid2: this.selectedBot.pageid,
        categoriesid: categoriesid.join(',')
      }

      try {
        var response = await this.transferShopService(data)
        if (response.message) {
          return Promise.resolve(response.message)
        }
        return Promise.reject()
      } catch (error) {
        return Promise.reject()
      }
    },
    toggleSelect: function(value) {
      var vm = this
      if (vm.comparelist) {
        vm.comparelist.map(function(compare, index) {
          vm.comparelist[index].selected = value
        })
      }
    },
    getCompareIntents(data) {
      return new Promise((resolve, reject) => {
        api.getCompareIntents(data, function(error, response) {
          if (error) {
            reject(error)
          } else {
            resolve(response)
          }
        })
      })
    },
    transferIntents(data) {
      return new Promise((resolve, reject) => {
        // data.intentstatus = false
        api.transferIntents(data, function(error, response) {
          if (error) {
            reject(error)
          } else {
            resolve(response)
          }
        })
      })
    },
    getCompareShopService(data) {
      return new Promise((resolve, reject) => {
        api.getcompareshopservice(data, function(error, response) {
          if (error) {
            reject(error)
          } else {
            resolve(response)
          }
        })
      })
    },
    transferShopService(data) {
      return new Promise((resolve, reject) => {
        api.transfershopservice(data, function(error, response) {
          if (error) {
            reject(error)
          } else {
            resolve(response)
          }
        })
      })
    }
  },
  watch: {
    showPreset(newVal) {
      if (newVal == false) {
        this.currentViewPreset = null
        this.currentPresetIndex = null
        this.selectedPremium = null
        if (this.$store.state.premiums && this.$store.state.premiums.length > 0) {
          this.selectedPremium = this.$store.state.premiums[0]
        }
      }
    },
    isSelected: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.selectAll = newVal == this.comparelist.length
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.package {
  cursor: pointer;
  &.left-border {
    border-left: 1px solid #ff706b;
  }
  &.right-border {
    border-right: 1px solid #ff706b;
  }
  &:hover {
    background: #ffb5b3;
  }
}

.preset {
  &.selected {
    border: #ff706b solid 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/getstarted/Presets.vue